import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../auth/auth.service';


export const rightsLoadedGuard: CanActivateFn = async (): Promise<boolean> => {
  const authService = inject(AuthService);

  if (authService.isAuthenticated() && !authService.rightsLoaded.value) {
    try {
      await authService.getEmployeeAccessModules();
    } catch (error) {
      // Never block the portal on this. A failed rights call leaves the menu as sparse as it is
      // today; a rejected guard would leave the employee staring at a blank page instead.
      console.error('Failed to preload employee access modules before the shell rendered:', error);
    }
  }

  return true;
};
